import React, { useState } from "react";
//@ts-ignore
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import { selectConfigData } from "../../redux/config/configSlice";
import { useAppSelector } from "../../redux/hooks";
import Loading from "../LoadingPage/Loading";

interface TelerikReportingProps {
  params: { [key: string]: any };
  reportName: string;
  reportEndPoint: string;
}

const TelerikReporting: React.FC<TelerikReportingProps> = ({
  params,
  reportName,
  reportEndPoint,
}) => {
  const [isLoading, setLoading] = useState<boolean>(true);
  const configData = useAppSelector(selectConfigData);
  const token = localStorage.getItem("jwtToken") ?? null;

  const reportSource = {
    report: reportName, // name of the report file that you want to render
    parameters: {
      ReportUrl: `${configData?.appApiBaseUrl}/${reportEndPoint}`,
      AuthToken: `Bearer ${token}`,
      ...params,
    },
  };

  const hideNonPdfExports = () => {
    document
      .querySelectorAll<HTMLElement>("[data-command-parameter]")
      .forEach((item) => {
        const format = item.getAttribute("data-command-parameter");
        if (format && format !== "PDF") {
          item.style.display = "none";
        }
      });
  };

  const handlePageReady = () => {
    setLoading(false);
    hideNonPdfExports();

    const largeMenu = document.querySelector(".trv-menu-large");
    largeMenu?.addEventListener("mouseover", hideNonPdfExports);

    const sideMenu = document.querySelector(".trv-side-menu");
    sideMenu?.addEventListener("click", hideNonPdfExports);
  };

  const handleError = () => {
    setLoading(false);
  };

  return (
    <div style={{ position: "relative", height: "100%", width: "100%" }}>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 10,
            background: "var(--background, #fff)",
          }}
        >
          <Loading />
        </div>
      )}
      <TelerikReportViewer
        reportSource={reportSource}
        viewerContainerStyle={{ height: "100%", width: "100%" }}
        serviceUrl={`${configData?.appApiBaseUrl}/reports`}
        scaleMode="FIT_PAGE_WIDTH"
        scale="1.0"
        enableAccessibility={false}
        pageReady={handlePageReady}
        error={handleError}
      />
    </div>
  );
};

export default TelerikReporting;